import { Injectable } from '@angular/core';
import { TranslocoLocaleService } from '@jsverse/transloco-locale';

@Injectable({ providedIn: 'root' })
export class TimezoneService {

	constructor(
		private translocoLocaleService: TranslocoLocaleService,
	) {}

	// Returns an array of timezones with their associated offset specified by the user's selected language/locale.
	public getTimezones(): { name: string, offset: string }[] {
		const now = new Date();
		const locale = this.translocoLocaleService.getLocale();

		return Intl.supportedValuesOf('timeZone').map(tz => {
			const offset = new Intl.DateTimeFormat(locale, {
				timeZone: tz,
				timeZoneName: 'shortOffset',
			}).formatToParts(now).find(p => p.type === 'timeZoneName')?.value;
			return { name: tz, offset: offset };
		});
	}
}